import { Answer, KeyFob, OwnershipType, VehicleService, VehicleType } from '../../api-client/enums'
import useVehiclePageData from './use-vehicle-page-data'
// ----------------------------------------------------------------------

const ownershipTypeOptions = {
  [OwnershipType.Own]: 'Owned',
  [OwnershipType.Finance]: 'Financed',
  [OwnershipType.Lease]: 'Leased',
}

const keyFobCountOptions = {
  [KeyFob.One]: '1',
  [KeyFob.Two]: '2',
  [KeyFob.Three]: '3',
}
const servicePlaceOptions = {
  [VehicleService.Dealer]: 'Dealer',
  [VehicleService.ThirdParty]: 'Third Party',
  [VehicleService.Both]: 'Dealership and Third Party',
}

// ----------------------------------------------------------------------

export default function Ownership() {
  const { vehicleData } = useVehiclePageData()

  const fieldsVisibilityConfig = {
    ownershipType: vehicleData?.vehicleType === VehicleType.Consumer,
    originalOwner: vehicleData?.vehicleType === VehicleType.Consumer,
    vehicleService: vehicleData?.vehicleType === VehicleType.Consumer,
    keyFob: vehicleData?.vehicleType === VehicleType.Consumer,
  }

  return (
    <div className='wrapper'>
      <h1>Ownership Details</h1>

      {fieldsVisibilityConfig.ownershipType && fieldsVisibilityConfig.originalOwner && (
        <div className='row flex'>
          {fieldsVisibilityConfig.ownershipType && (
            <div>
              <span className='label'>Ownership</span>
              <p>{ownershipTypeOptions[vehicleData.ownershipType]}</p>
            </div>
          )}

          {fieldsVisibilityConfig.originalOwner && (
            <div>
              <span className='label'>Original Owner</span>
              <p>{vehicleData.originalOwner === Answer.Yes ? 'Yes' : 'No'}</p>
            </div>
          )}
        </div>
      )}

      <div className='row flex'>
        {fieldsVisibilityConfig.vehicleService && (
          <div>
            <span className='label'>Serviced By</span>
            <p>{servicePlaceOptions[vehicleData.vehicleService]}</p>
          </div>
        )}
        <div>
          <span className='label'>Service Records</span>
          <p>{vehicleData.serviceRecordsAvailable === Answer.Yes ? 'Available' : 'Unavailable'}</p>
        </div>
        {!fieldsVisibilityConfig.keyFob && (
          <div>
            <span className='label'>Smoking</span>
            <p>{vehicleData.smokedIn === Answer.Yes ? 'Smoker' : 'Non-smoker'}</p>
          </div>
        )}
      </div>
      {fieldsVisibilityConfig.keyFob && (
        <div className='row flex'>
          <div>
            <span className='label'>Key Fobs</span>
            <p>{keyFobCountOptions[vehicleData.keyFob]}</p>
          </div>
          <div>
            <span className='label'>Smoking</span>
            <p>{vehicleData.smokedIn === Answer.Yes ? 'Smoker' : 'Non-smoker'}</p>
          </div>
        </div>
      )}
      <div className='row flex'>
        <div>
          <span className='label'>Damage</span>
          <p>
            {vehicleData.damaged === Answer.Yes ? 'Yes' : 'No'}
            {vehicleData.costOfRepairAfterDamage &&
              `. Estimated repair: $${vehicleData.costOfRepairAfterDamage.toLocaleString()}`}
          </p>
        </div>
        <div>
          <span className='label'>Accident</span>
          <p>
            {vehicleData.hadAccident === Answer.Yes ? 'Yes' : 'No'}
            {vehicleData.costOfRepairAfterAccident &&
              `. Estimated repair: $${vehicleData.costOfRepairAfterAccident.toLocaleString()}`}
          </p>
        </div>
      </div>
      <div className='row flex'>
        <div>
          <span className='label'>Modifications</span>
          <p>{vehicleData.vehicleHasModifications === Answer.Yes ? 'Yes' : 'No'}</p>
        </div>
        <div>
          <span className='label'>Modification Details</span>
          <p>{vehicleData.modificationDetails || 'No details provided'}</p>
        </div>
      </div>
      <div className='row flex'>
        <div>
          <span className='label'>Rebuilt</span>
          <p>{vehicleData.rebuilt === Answer.Yes ? 'Yes' : 'No'}</p>
        </div>
      </div>

      <style jsx>{`
        .wrapper {
          padding: 3.3rem 0;

          h1 {
            margin: 0 0 3rem;
            line-height: 4.3rem;
            font-size: 3.2rem;
            font-weight: bold;
          }

          .row {
            width: 100%;
            padding: 0 0 3.65rem;
            margin: 0 0 2rem;
            border-bottom: 1px solid var(--secondary-text-color);

            :last-child {
              padding: 0;
              margin: 0;
              border-bottom: none;
            }

            div {
              flex: 1;

              .label,
              p {
                display: inline-block;
                line-height: 2.4rem;
                font-size: 1.8rem;
              }

              .label {
                min-width: 19.5rem;
              }

              p {
                font-weight: 700;
              }
            }
          }
        }

        @media (min-width: 1025px) and (max-width: 1364px) {
          .wrapper {
            padding: 2.9rem 0;

            h1 {
              margin: 0 0 2.5rem;
              font-size: 2rem;
            }

            .row {
              width: 100%;
              padding: 0 0 1.45rem;
              margin: 0 0 1.8rem;

              div {
                .label,
                p {
                  line-height: 1.9rem;
                  font-size: 1.4rem;
                }

                p {
                  font-weight: 700;
                }
              }
            }
          }
        }

        @media (max-width: 1024px) {
          .wrapper {
            h1 {
              margin: 0 0 2rem;
              line-height: 2.7rem;
              font-size: 2rem;
            }

            .row {
              flex-direction: column;
              margin: 0;
              padding: 0;
              border-bottom: none;

              :last-child div :last-child {
                border-bottom: none;
              }

              div {
                margin: 0 0 1.45rem;
                padding: 0 0 1.65rem;
                border-bottom: 1px solid var(--secondary-text-color);

                .label,
                p {
                  min-width: 50%;
                  font-size: 1.4rem;
                }
              }
            }
          }
        }
      `}</style>
    </div>
  )
}
